import { isUndefined } from '../../helpers/index'

export function support(api) {
  return !isUndefined(bridge[api])
}

const bridge = {
  fn: () => {

  },
  setTitleText(title) {
    const titleDom = document.getElementsByTagName('title')[0]
    titleDom && (titleDom.innerHTML = title)
  },
  // report: Reporter.log,
  getAppVersion: callback => {
    setTimeout(() => {
      callback('9.9.9-test')
    }, 200)
  }
}

export default bridge;
